import FormError from '@/components/FormError';
import { useIntl } from 'react-intl';

const ERROR_MESSAGE_TO_FIELD_MAPPING: Record<string, string> = {
  'The requested qty is not available': 'quantity',
  'Product that you are trying to add is not available.': 'quantity',
  "The product that was requested doesn't exist.": 'quantity',
};

const ERROR_FIELD_TO_MESSAGE_MAPPING: Record<string, string> = {
  quantity: 'The requested quantity is not available.',
};

export const ProductFormError = ({
  errorMessage,
  failedToCart = false,
}: {
  errorMessage: string;
  failedToCart?: boolean;
}) => {
  const { formatMessage } = useIntl();

  if (!errorMessage && !failedToCart) {
    return null;
  }

  // Fill a map with field/section -> error.
  const errors = new Map();

  if (errorMessage) {
    Object.keys(ERROR_MESSAGE_TO_FIELD_MAPPING).forEach(key => {
      if (errorMessage.includes(key)) {
        const target = ERROR_MESSAGE_TO_FIELD_MAPPING[key];
        const message = ERROR_FIELD_TO_MESSAGE_MAPPING[target];

        errors.set(target, message);
      }
    });

    // Handle cases where a user token is invalid or expired. Preferably
    // this would be handled elsewhere with an error code and not a string.
    if (errorMessage.includes('The current user cannot')) {
      errors.set('form', [
        new Error(
          formatMessage({
            id: 'productFullDetail.errorToken',
            defaultMessage:
              'There was a problem with your cart. Please sign in again and try adding the item once more.',
          }),
        ),
      ]);
    }

    // Handle cases where a cart wasn't created properly.
    if (errorMessage.includes('Variable "$cartId" got invalid value null')) {
      errors.set('form', [
        new Error(
          formatMessage({
            id: 'productFullDetail.errorCart',
            defaultMessage:
              'There was a problem with your cart. Please refresh the page and try adding the item once more.',
          }),
        ),
      ]);
    }

    // An unknown error should still present a readable message.
    if (!errors.size) {
      errors.set('form', [
        new Error(
          formatMessage({
            id: 'productFullDetail.errorUnknown',
            defaultMessage: 'Could not add item to cart. Please check required options and try again.',
          }),
        ),
      ]);
    }
  }

  return (
    <FormError
      classes={{
        root: 'my-0 px-0 pt-xs ',
      }}
      errors={(Array.isArray(errors.get('form')) ? errors.get('form') : []).concat(
        failedToCart ? [new Error('Failed to create a new cart, Please refresh the page and try again')] : [],
      )}
    />
  );
};
